<!--安全检查总结-->
<template>
  <div style="width: 100%; height: 100%; position: absolute">
    <h1
      style="width: 100%; height: 70px; position: absolute; color: white; font-weight: bold; font-size: 42px; line-height: 70px; padding-left: 20px; text-align: left">
      Manpower
    </h1>
    <div v-if="dataNotNull" key="1" class="checkDiv"
         style="width: 100%; height: 100%; position: absolute; bottom: 0">
      <div class="container1" style="height: 100%;display: flex">
        <div style="color: white;text-align: left;margin-top: 13%;margin-left: 10%">
          <div style="margin-top: 10px;">Before CB</div>
          <div style="margin-top: 20px">Green Access Code</div>
          <div style="margin-top: 20px">Work On Site</div>
          <div style="margin-top: 20px">Balance</div>
        </div>
        <div style="color: #66CCFF;text-align: right;margin-top: 13%;margin-left: 20%">
          <div style="margin-top: 10px">{{ bcb }}</div>
          <div style="margin-top: 20px">{{ gac }}</div>
          <div style="margin-top: 20px">{{ wos }}</div>
          <div style="margin-top: 20px">{{ bal }}</div>
        </div>

      </div>
    </div>
    <div v-else key="2"
         style="width: 100%; height: 100%; position: absolute; bottom: 0; line-height: 793px; color: #6CF; font-size: 64px;">
      No Data !
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import axios from 'axios'

export default {
  props: ['project_id'],
  name: "manpower",
  data() {
    return {
      color: this.$store.state.color.chart_color,
      name: "manpower",
      dataNotNull: true,
      bcb: 98,
      gac: 77,
      wos: 43,
      bal: 34
    }
  },
  methods: {
    init() {
      // this.$root.charts.push(this.myChart)
      this.myChart.resize()
      window.addEventListener("resize", function () {
        this.myChart.resize()
      }.bind(this))
    },
    //获取当前日期，格式YYYY-MM-DD
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    }
  },
  mounted() {
    let that = this
    let postData = {
      project_id: this.project_id,
      bes_project_id: window.localStorage.getItem('bes_project_id'),
      start_date: this.getNowFormatDate(),
      end_date: this.getNowFormatDate(),
      user: window.localStorage.getItem("token_key"),
      token: window.localStorage.getItem('token')
    }
    // axios.post(this.$store.getters.getCmsServer + "DBProjCheckStatus", postData).then(resp => {
    //     var errNo = resp.data.errno
    //     var errStr = resp.data.errstr_cn
    //     if (errNo == "0") {
    //         this.dataNotNull = true
    //         var result = resp.data.result;
    //         var data = this.analysisResult(result)
    //         this.myChart.setOption({
    //             series: [
    //                 {
    //                     data: data.totle
    //                 },
    //                 {
    //                     data: data.assists,
    //                     label: {
    //                         normal: {
    //                             show: true,
    //                             color: '#6cf',
    //                             position: 'insideRight',
    //                             formatter: function (params) {
    //                                 return parseInt(params.value) - parseInt(data.assist);
    //                             }
    //                         }
    //                     },
    //                 },
    //                 {
    //                     data: data.checkes
    //                 }
    //             ]
    //         })
    //     } else {
    //         this.dataNotNull = false
    //     }
    // }).catch(error => {
    //     alert(error)
    //     this.dataNotNull = false
    // })
    // this.init()
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
</style>



// WEBPACK FOOTER //
// src/components/HCS/manpower.vue